import React from "react";
import "./Footer.css";
import { Link as LinkR } from "react-router-dom";
const Footer = () => {
  const date = new Date().getFullYear();
  return (
    <footer>
      <div className="footer-wrapper">
        <div className="footer-wrapper__top">
          <div className="footer-wrapper__items">
            <div className="footer-wrapper__item">
              <LinkR className="navbar__title" to="/">
                TSS<span>Club</span>
                <p>Our tribute to The beautiful game</p>
              </LinkR>
            </div>
            <div className="footer-wrapper__item">
              <h4>Connect with us</h4>
              <div className="footer-wrapper__items">
                <a href="https://twitter.com/TssAcademy" className="icon-button twitter" target={"_blank"}><i className="fa fa-twitter"></i></a>
                <a href="https://www.facebook.com/TSS-Academy-110666961621389" className="icon-button facebook" target={"_blank"}><i className="fa fa-facebook"></i></a>
                <a href="https://www.instagram.com/tssinfoofficial/" className="icon-button google-plus" target={"_blank"}><i className="fa fa-instagram"></i></a>
                <a href="https://www.youtube.com/channel/UCLeU8WiWfU7w2eHXFsAVlMQ/about" className="icon-button youtube" target={"_blank"}><i className="fa fa-youtube"></i></a>
                {/*<a href="#" className="icon-button pinterest"><i className="fa fa-pinterest"></i></a>*/}
              </div>
            </div>
          </div>
          {/*<div className="footer-wrapper__items">*/}
          {/*  <div className="footer-wrapper__item">*/}
          {/*    <h4>Fitness Club</h4>*/}
          {/*    <a href="/">Pricing</a>*/}
          {/*    <a href="/">Events</a>*/}
          {/*    <a href="/">Articles</a>*/}
          {/*    <a href="/">Our Instructors</a>*/}
          {/*  </div>*/}
          {/*  <div className="footer-wrapper__item">*/}
          {/*    <h4>Our Newsletter</h4>*/}
          {/*    <form>*/}
          {/*      <input placeholder="Your Email" />*/}
          {/*      <button className="btn primary">Subscribe</button>*/}
          {/*    </form>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>

        <div className="footer-wrapper__copyright">
          <small>{date} &copy; TSS Club, All Rights Reserved </small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
